import React from 'react'
// import { useTranslations } from "next-intl";
import styles from "./Footer.module.css"
import { useSelector } from 'react-redux';
export default function Footer() {
  const { currentLocal } = useSelector((state) => state.currentLocal);

  return (
    <div className={styles.footerContainer}>
      <p className="p-0 m-0 text-base ">{currentLocal.general.Rights}{" "}{currentLocal.general.nanoSoft}{" "}2022</p>
    </div>
  )
}
